export const intersection = <T extends string | number>(firstArray: T[], secondArray: T[]): T[] => {
	return [...new Set(firstArray.filter((value) => secondArray.includes(value)))]
}

export const intersectionN = <T extends string | number>(firstA: T[], secondA: T[]): T[] => {
	const map = firstA.reduce((acc, item) => {
		acc[item] = true
		return acc
	}, {} as Record<T, boolean>)

	return [
		...secondA.reduce((acc, i) => {
			if (map[i]) {
				acc.add(i)
			}
			return acc
		}, new Set<T>()),
	] as T[]
}
